import React from 'react';
import { MultiValueGenericProps } from 'react-select/src/components/MultiValue';

import { Option } from '../option.model';

export const MultiValueContainer = ({
  children,
  innerProps,
}: MultiValueGenericProps<Option>) => (
  <div
    {...innerProps}
    className="multi-value-container flex items-center min-w-0 border border-primary-500 rounded"
  >
    {children}
  </div>
);
